import template from './file-upload-preview.html';

export default angular
  .module('app')
  .directive('holdingFileUploadPreview', holdingFileUploadPreview)
  .name;

function holdingFileUploadPreview() {
  'ngInject';

  return {
    link,
    replace: true,
    require: 'ngModel',
    restrict: 'E',
    scope: {
      progress: '=?'
    },
    template,
  };

  function link(scope, _element, _attrs, ctrl) {
    const model = {
      document: null
    };

    function ctrlValueUpdated(newDoc) {
      scope.model.document = newDoc;
    }

    function documentModelUpdated(newDoc, oldDoc) {
      if (newDoc !== oldDoc) {
        ctrl.$setViewValue(newDoc);
      }
    }

    function rejectFile(index) {
      if (scope.model.document && scope.model.document.length > 1) {
        scope.model.document.splice(index, 1);
      } else {
        scope.model.document = [];
      }
    }

    scope.model = model;
    scope.rejectFile = rejectFile;

    scope.$watch('model.document', documentModelUpdated);
    scope.$watch(() => ctrl.$viewValue, ctrlValueUpdated);
  }
}



// WEBPACK FOOTER //
// ./src/holding/modules/app/directives/file-upload-preview/file-upload-preview.js